module.exports = __webpack_public_path__ + "static/img/doc.ae616588.png";